<!-- fix mozilla background-attachment "bug" https://css-tricks.com/the-fixed-background-attachment-hack/ -->
<div class="bg" [ngClass]="{ 'bg-red': isTest, 'horizontal-mirror': isMirrored }"></div>
<div id="test-system" *ngIf="isTest">TESZT RENDSZER!!</div>

<div class="content">
   <!-- the communication language is chosen on the home page instead -->
   <!-- <button id="change-lang" mat-raised-button (click)="toggleLang()">{{
      currentLang === 'hu' ? 'English' : 'Magyar'
   }}</button> -->
   <div
      style="position: absolute; left: 10vw; top: calc(2vh + 36px); transform: translateY(-50%)"
      *ngIf="isLoggedIn()"
   >
      <button
         mat-raised-button
         [ngClass]="url.startsWith('/admin') ? 'mat-primary' : 'mat-secondary'"
         (click)="onEnrollment()"
         >{{ currentLang === 'hu' ? 'Beiratkozás' : 'Enrollment' }}</button
      >

      <button
         mat-raised-button
         [ngClass]="url.startsWith('/supplements') ? 'mat-primary' : 'mat-secondary'"
         (click)="onSupplements()"
         style="margin-left: 1vw"
         >{{ currentLang === 'hu' ? 'Dokumentumfeltöltés' : 'Document upload' }}</button
      >

      <button
         mat-raised-button
         [ngClass]="url === '/chaos-table' ? 'mat-primary' : 'mat-secondary'"
         (click)="onChaosTable()"
         style="margin-left: 1vw"
         [disabled]="!authService.hasResource(Resources.CTMenu)"
         >{{ 'Chaos Table' | translate }}</button
      >

      <button
         mat-flat-button
         style="margin-left: 1rem; border-radius: 1000px"
         color="primary"
         (click)="navigateToHistory()"
         [ngClass]="url === '/chaos-table/history' ? 'mat-primary' : 'mat-secondary'"
         [disabled]="!authService.hasResource(Resources.CTHistoryMenu)"
      >
         {{ 'History' | translate }}
      </button>

      <button
         mat-raised-button
         [ngClass]="url === '/dictionary' ? 'mat-primary' : 'mat-secondary'"
         (click)="onDictionary()"
         style="margin-left: 1vw"
         [disabled]="!authService.hasResource(Resources.DictionaryMenu)"
         >{{ 'Dictionary' | translate }}</button
      >

      <button
         mat-raised-button
         [ngClass]="url === '/email-log' ? 'mat-primary' : 'mat-secondary'"
         (click)="onEmailAudit()"
         style="margin-left: 1vw"
         >{{ 'Email log' | translate }}</button
      >

      <button mat-raised-button color="warn" (click)="onLogout()" style="margin-left: 3vw">{{
         currentLang === 'hu' ? 'Kijelentkezés' : 'Logout'
      }}</button>
   </div>

   <router-outlet></router-outlet>
</div>
<div id="cancel-btn" *ngIf="showClear">
   <button mat-fab color="warn" (click)="onReset()">
      <mat-icon>clear</mat-icon>
   </button>
</div>
